import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Icon, Input, Button, Form, Row } from 'antd';
import { hasErrors } from 'util/FormUtils.jsx';

const FormItem = Form.Item;

class SuperUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
  }

  onChangeUser = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.warn(values.codFisc);
        this.props.onChangeUser(values.codFisc, this.props.acYear);
        this.setState({
          ...this.state,
          clicked: false,
        })
      }
    })
  }

  handleClickChange = (visible) => {
    this.setState({
      clicked: visible,
    });
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const style = { width: '281px' };
    const impersonificate = (
      <Form style={style} className="simple-form" onSubmit={this.onChangeUser} layout="vertical">
        <Row gutter={16}>
          <FormItem label="CF Utente">
            {getFieldDecorator('codFisc', { 
              rules: [{ required: true, message: 'Inserire il CF dell\'utente da impersonificare'}] 
              })(
              <Input
                placeholder="CF utente da impersonare"
              />
            )}
          </FormItem>
        </Row>
        <Row gutter={16}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={hasErrors(getFieldsError())}
            style={{ width: '100%' }}
          >
            Conferma
          </Button>
        </Row>
      </Form>
    );

    // <i className="fa fa-users fa-lg" />
    if (this.props.user && this.props.user.registriUserType === 'A') {
      return (
        <Popover 
          content={impersonificate} 
          title="Impersonificazione docente" 
          trigger="click"
          onVisibleChange={this.handleClickChange}
          visible={this.state.clicked}
          >
            <Icon type="usergroup-add" />
        </Popover>
      );
    }
    return (null);
  }
}

SuperUser.propTypes = {
  user: PropTypes.object,
  acYear: PropTypes.string.isRequired,
  onChangeUser: PropTypes.func,
};

const WrappedSuperUser = Form.create()(SuperUser);

export default WrappedSuperUser;
